import { apiAuth, apiPublic } from '../config/api';

export const getDealerAvailableTimeSlots = async ({ id, date }) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    return await apiPublic.fetch(`/api/schedule/available/${id}/${formattedDate}`);
}

/**
 * @param {Object} data
 * @param {string} data.offerId
 * @param {string} data.date
 * @param {Object} data.timeSlot
 * @param {string} data.timeSlot.start
 * @param {string} data.timeSlot.end

 */
export const bookAppointment = async (data) => {
    return await apiPublic.fetch(`/api/schedule/book`, {
        method: 'POST',
        body: data
    });
}

export async function getDealerAppointments({ startDate, endDate }) {
    return await apiAuth.fetch(`/api/schedule/dealer?startDate=${startDate}&endDate=${endDate}`, {
        method: 'GET',
    });
}

export async function updateAppointmentStatus(appointmentId, payload) {
    return await apiAuth.fetch(`/api/schedule/${appointmentId}/status`, {
        method: 'PATCH',
        body: payload,
    });
} 